var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./VueBootstrapTypeaheadList.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-900efda8\"}!../../../vue-loader/lib/selector?type=template&index=0!./VueBootstrapTypeaheadList.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bootstrap-typeahead/src/components/VueBootstrapTypeaheadList.vue
// module id = 1098
// module chunks = 5